{
  "title": "Report crop damage",
  "lead": "Tell the Municipal Agriculture Office which crops were damaged. Your report helps with assistance and goes into the damage report for the province and the Department of Agriculture.",
  "noAccountNeeded": "You don't need an account. Reports are saved on your phone first, so you can send them even with weak signal.",
  "eventLabel": "Disaster event",
  "eventNone": "Not linked to a disaster event",
  "farmerSection": "About you",
  "farmerName": "Farmer's full name",
  "mobileHint": "The office may text or call you about the field visit.",
  "rsbsa": "RSBSA number",
  "rsbsaHint": "Optional. It helps with eligibility for assistance.",
  "barangay": "Barangay where the farm is",
  "plotsSection": "Damaged crops",
  "plotsHint": "Add each crop or plot separately.",
  "plotTitle": "Crop {n}",
  "addPlot": "Add another crop or plot",
  "removePlot": "Remove crop {n}",
  "crop": "Crop",
  "chooseCrop": "Choose a crop",
  "cropOther": "Name of the crop",
  "farmLocation": "Farm location",
  "farmLocationHint": "Optional. Use your location while you are at the farm, or tap the map.",
  "mapLabel": "Map for choosing the farm location",
  "areaPlanted": "Area planted",
  "areaAffected": "Area affected",
  "unitLegend": "Area unit",
  "unit_sqm": "m²",
  "unit_ha": "hectares",
  "growthStage": "Growth stage",
  "stage_seedling": "Seedling",
  "stage_vegetative": "Vegetative",
  "stage_flowering": "Flowering",
  "stage_ready_for_harvest": "Ready for harvest",
  "extent": "Extent of damage",
  "extent_partial": "Partially damaged",
  "extent_total": "Totally damaged",
  "cause": "Cause",
  "cause_typhoon": "Typhoon",
  "cause_flood": "Flood",
  "cause_landslide": "Landslide",
  "cause_frost": "Frost",
  "cause_hail": "Hail",
  "cause_drought": "Drought",
  "cause_pests_disease": "Pests or disease",
  "cause_other": "Other",
  "causeOther": "Describe the cause",
  "damageDate": "Date the damage happened",
  "pcic": "Is this crop insured with PCIC?",
  "pcic_yes": "Yes",
  "pcic_no": "No",
  "pcic_unknown": "Not sure",
  "photos": "Photos of the damage",
  "loss": "Estimated value of the loss (₱)",
  "lossHint": "Optional. Your own estimate is fine.",
  "submit": "Send report",
  "sending": "Sending…",
  "fixErrors": "Please check the highlighted fields.",
  "photoRequired": "Add at least one photo of the damage.",
  "queuedTitle": "Saved — will send when online",
  "queuedBody": "Your report is saved on this phone and will send by itself when you have signal. You can close the app.",
  "pendingTitle": "Waiting to send",
  "failedItem": "Could not send: {error}",
  "discard": "Remove",
  "sendNow": "Try sending now",
  "newReport": "Report another farm",
  "trackTitle": "Crop damage report",
  "reportedOn": "Reported {date}",
  "officerNote": "Note from the Agriculture Office",
  "timeline": "Updates",
  "plotsTitle": "What you reported",
  "affectedOf": "{affected} of {planted} affected",
  "notFound": "We couldn't find this report. Open it from the link you got after sending it.",
  "savedCopy": "You're offline. Showing the copy saved on this phone.",
  "keepLink": "Keep this page. Its link lets you check the status later.",
  "status_submitted": "Submitted",
  "status_for_validation": "For validation",
  "status_validated": "Validated",
  "status_included": "Included in damage report",
  "status_not_eligible": "Not eligible",
  "statusHelp_submitted": "The Agriculture Office received your report.",
  "statusHelp_for_validation": "An officer will visit or contact you to check the damage.",
  "statusHelp_validated": "The field visit is done and the damage was confirmed.",
  "statusHelp_included": "Your farm is included in the damage report sent to the province and the DA.",
  "statusHelp_not_eligible": "This report was not included. See the note from the office.",
  "updateNote": "Note",
  "promptTitle": "Was your farm affected by {event}?",
  "promptBody": "Report damaged crops so the Agriculture Office can include you in the damage report.",
  "promptCta": "Report crop damage",
  "myTitle": "My crop damage reports",
  "myEmpty": "No crop damage reports yet.",
  "plotCount": "{n} crops",
  "plotCountOne": "1 crop",
  "dashboardTitle": "Crop damage",
  "dashboardLead": "Validate farmers' reports and prepare the damage report for the province and the DA.",
  "tabReports": "Reports",
  "tabSummary": "Summary",
  "tabEvents": "Disaster events",
  "filterEvent": "Event",
  "allEvents": "All events",
  "allBarangays": "All barangays",
  "allCrops": "All crops",
  "allCauses": "All causes",
  "allStatuses": "All statuses",
  "searchLabel": "Search name, mobile, RSBSA or reference",
  "listView": "List",
  "mapView": "Map",
  "reportsMapLabel": "Map of farms in the listed reports",
  "noLocation": "{n} reports without a farm location are not on the map.",
  "noReports": "No reports match these filters.",
  "noReportsYet": "No crop damage reports yet. Farmers can report from the app at any time.",
  "affectedHa": "{ha} affected",
  "exportCsv": "Download CSV",
  "printReport": "Printable report",
  "exportHint": "Exports validated reports and those included in the damage report.",
  "rsbsaNone": "No RSBSA number",
  "validationTitle": "Validation",
  "officerNoteLabel": "Note to the farmer",
  "officerNoteHint": "The farmer sees this note on their tracking screen.",
  "internalNoteLabel": "Internal note",
  "internalNoteHint": "Only staff see this.",
  "validatedArea": "Validated area affected (ha)",
  "validatedExtent": "Validated extent",
  "sameAsReported": "Same as reported",
  "saveValidation": "Save validation",
  "validationSaved": "Validation saved.",
  "validatedBy": "Validated by {name} on {date}",
  "reported": "Reported",
  "planted": "Planted",
  "viewOnly": "You can view reports. Editors validate them.",
  "submittedOffline": "Saved on the phone {date}",
  "farmers": "Farmers",
  "reports": "Reports",
  "haAll": "Hectares affected",
  "haPartial": "Partially damaged",
  "haTotal": "Totally damaged",
  "estLoss": "Estimated loss",
  "byStatus": "Reports by status",
  "byCrop": "Hectares affected by crop",
  "byBarangay": "Hectares affected by barangay",
  "chartNote": "Validated areas are used once a report is validated. Reports marked not eligible are not counted. Farmers are counted once (by RSBSA number, otherwise mobile).",
  "showTable": "Show as table",
  "hideTable": "Hide table",
  "colName": "Name",
  "colPartial": "Partial (ha)",
  "colTotal": "Total (ha)",
  "colAll": "All (ha)",
  "colPlots": "Plots",
  "colFarmers": "Farmers",
  "noSummary": "No counted reports for this selection yet.",
  "chooseEvent": "Choose a disaster event to see its totals.",
  "newEvent": "Open a disaster event",
  "newEventHint": "While an event is open, the home screen asks farmers to report crop damage and new reports are linked to it.",
  "eventName": "Name",
  "eventNameHint": "For example: Typhoon ___, Oct 2026",
  "eventType": "Type",
  "type_typhoon": "Typhoon",
  "type_flood": "Flood",
  "type_landslide": "Landslide",
  "type_frost": "Frost",
  "type_drought": "Drought",
  "type_earthquake": "Earthquake",
  "type_other": "Other",
  "startedAt": "Started on",
  "eventNotes": "Notes",
  "openEvent": "Open event",
  "closeEvent": "Close event",
  "reopenEvent": "Reopen",
  "eventOpened": "Disaster event opened.",
  "eventClosed": "Disaster event closed.",
  "eventReopened": "Disaster event reopened.",
  "closeConfirm": "Close {name}? Farmers will no longer be prompted to report for it.",
  "active": "Active",
  "closed": "Closed",
  "eventsEmpty": "No disaster events yet.",
  "eventMeta": "Started {date} · {n} reports",
  "eventEnded": "Closed {date}",
  "adminEventsTitle": "Disaster events",
  "adminEventsLead": "Open an event during a typhoon, flood, landslide or frost so farmers are prompted to report crop damage.",
  "printTitle": "Crop damage report",
  "printEvent": "Disaster event: {name}",
  "printAll": "All disaster events",
  "printGenerated": "Generated {date}",
  "printStatuses": "Includes reports that are validated or included in the damage report.",
  "printButton": "Print",
  "backToDashboard": "Back to crop damage",
  "printPreparedBy": "Prepared by: ____________________",
  "printNotedBy": "Noted by: ____________________",
  "colRef": "Reference",
  "colFarmer": "Farmer",
  "colRsbsa": "RSBSA",
  "colBarangay": "Barangay",
  "colCrop": "Crop",
  "colPlanted": "Planted (ha)",
  "colAffected": "Affected (ha)",
  "colExtent": "Extent",
  "colStage": "Stage",
  "colCause": "Cause",
  "colDate": "Date of damage",
  "colPcic": "PCIC",
  "colLoss": "Est. loss (₱)",
  "totals": "Totals",
  "fieldRequired": "Please fill this in.",
  "chooseOne": "Choose one.",
  "enterNumber": "Enter a number, for example 0.5.",
  "addLocation": "Add farm location",
  "hideLocation": "Hide map",
  "locationSet": "Location added",
  "photoHint": "Take clear photos of the damaged crops. At least 1, up to 4.",
  "eventHint": "Reports are grouped by disaster event for the damage report."
}
